import { Operation } from "../../../entity/Operation";
import { Product } from "../../../entity/Product";
import { Method, ROUTES, URLs } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { ProductDTO } from "../../dto/Product.Dto";
import { mapToProduct } from "../../mapper/ProductMapper";

export class WSProduct {
  private static instance: WSProduct;
  private constructor() {}

  /**
   * Singleton instance
   */
  public static getInstance(): WSProduct {
    if (!WSProduct.instance) {
      WSProduct.instance = new WSProduct();
    }
    return WSProduct.instance;
  }

  async getAllProducts(storeId: string): Promise<Product[]> {
    try {
      const url = `${ROUTES.PRODUCTS}${storeId}`;

      const response = await fetchAPI<ProductDTO[]>({
        url,
        method: Method.GET,
        params: {},
        isAuthenticated: true,
      });
      return mapToProduct(response.data);
    } catch (error) {
      console.error("Get all operations failed:", error);
      throw error;
    }
  }

  async createProduct(product: Product): Promise<string> {
    try {
      const url = `${ROUTES.PRODUCTS}${ROUTES.CREATE_PRODUCT}`;

      const response = await fetchAPI<string>({
        url,
        method: Method.POST,
        params: product,
        isAuthenticated: true,
      });

      return response.data;
    } catch (error) {
      console.error("Create product failed:", error);
      throw error;
    }
  }

  async updateProduct(product: Product): Promise<void> {
    try {
      const url = `${ROUTES.PRODUCTS}`;

      await fetchAPI<void>({
        url,
        method: Method.PUT,
        params: product,
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Update product failed:", error);
      throw error;
    }
  }

  async deleteProduct(productId: string): Promise<void> {
    try {
      const url = `${ROUTES.PRODUCTS}${ROUTES.DELETE_PRODUCT}`;

      await fetchAPI<void>({
        url,
        method: Method.POST,
        isAuthenticated: true,
        params: { id: productId },
      });
    } catch (error) {
      console.error("Delete product failed:", error);
      throw error;
    }
  }
}
